export const extractServerErrorMessage = (responseBody: any): string | null => {
  if (!responseBody) return null;

  // Handle string responses - try to parse as JSON first
  if (typeof responseBody === "string") {
    // If it looks like JSON, try to parse it
    const trimmed = responseBody.trim();
    if (
      (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
      (trimmed.startsWith("[") && trimmed.endsWith("]"))
    ) {
      try {
        const parsed = JSON.parse(trimmed);
        return extractServerErrorMessage(parsed);
      } catch {
        // If parsing fails, return the string as-is
      }
    }
    return responseBody;
  }

  if (Array.isArray(responseBody)) return responseBody.join(" ");

  // Handle standardized error formats
  if (responseBody?.detail && typeof responseBody.detail === "string") {
    return responseBody.detail;
  }
  if (responseBody?.error && typeof responseBody.error === "string") {
    return responseBody.error;
  }

  if (Array.isArray(responseBody?.non_field_errors)) {
    return responseBody.non_field_errors.join(" ");
  }

  const flattened = Object.values(responseBody)
    .flat()
    .filter(Boolean) as string[];
  return flattened.length ? flattened.join(" ") : null;
};
